module.exports = __webpack_public_path__ + "img/CZC.ff649b98.svg";